import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { WebService } from '../api/web.service'
import { AppState } from 'src/app/store/state/app.state'
import { KnowledgeAPIModel, PaginatedAPI } from 'src/app/models/api.model'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { BehaviorSubject, map } from 'rxjs'
import { search_knowledge_action, view_knowledge_action } from 'src/app/store/action/knowledge.action'

@Injectable({
  providedIn: 'root'
})
export class KnowledgeService {
  knowledgeRefresh = new BehaviorSubject(false)

  constructor(private webservice: WebService, private appState: Store<AppState>) {}

  callSaveApi = (knowledge: KnowledgeAPIModel) => {
    const endPoint = ServiceUrlConstants.API_SAVE_KNOWLEDGE
    return this.webservice.post(endPoint, knowledge).pipe(map((data: KnowledgeAPIModel) => data))
  }

  dispatchViewKnowledgeAction(id: string) {
    this.appState.dispatch(view_knowledge_action({ id }))
  }

  callViewApi = (id: string) => {
    const endPoint = `${ServiceUrlConstants.API_VIEW_KNOWLEDGE}${id}`
    return this.webservice.get(endPoint).pipe(map((data: KnowledgeAPIModel) => data))
  }

  dispatchSearchKnowledgeAction(option) {
    this.appState.dispatch(search_knowledge_action(option))
  }

  invokeKnowledgeSummaryAPI = (queryParams: { key: string; value: string }[], searchRequestBody) => {
    return this.webservice
      .post(ServiceUrlConstants.API_VIEW_KNOWLEDGE_SEARCH_LIST, searchRequestBody, null, queryParams)
      .pipe(map((data: PaginatedAPI<KnowledgeAPIModel>) => data))
  }
}
